import React from 'react';
import { Outlet } from 'react-router-dom';
import SidebarMenu from './SidebarMenu';
import { useSidebar } from '../Context/SidebarContext';

/**
 * AdminLayout — wraps CRM, Finance, and other super-admin pages
 * inside the purple dashboard sidebar so navigation stays consistent.
 */
const AdminLayout = () => {
  const { expanded } = useSidebar();

  return (
    <div className="flex min-h-screen bg-gray-50 overflow-hidden">
      <SidebarMenu />
      <div
        className={`flex-1 overflow-auto transition-all duration-300 ${
          expanded ? 'md:ml-64' : 'md:ml-20'
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
